export default [
  {
    path: "*",
    meta: {
      public: true
    },
    redirect: {
      path: "/404"
    }
  },
  {
    path: "/404",
    meta: {
      public: true
    },
    name: "NotFound",
    component: () =>
      import(/* webpackChunkName: "routes" */
      `@/views/NotFound.vue`)
  },
  {
    path: "/403",
    meta: {
      public: true
    },
    name: "AccessDenied",
    component: () =>
      import(/* webpackChunkName: "routes" */
      `@/views/Deny.vue`)
  },
  {
    path: "/500",
    meta: {
      public: true
    },
    name: "ServerError",
    component: () =>
      import(/* webpackChunkName: "routes" */
      `@/views/Error.vue`)
  },
  {
    path: "/login",
    meta: {
      public: true
    },
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "routes" */
      `@/views/Login.vue`)
  },
  {
    path: "/",
    meta: {},
    name: "Root",
    title: "Home",
    redirect: {
      name: "Dashboard"
    }
  },
  {
    path: "/dashboard",
    meta: { breadcrumb: true, auth: true },
    title: "Home",
    name: "Dashboard",
    component: () =>
      import(/* webpackChunkName: "routes" */
      `@/views/Dashboard.vue`)
  },
  {
    path: "/romaneios",
    meta: { breadcrumb: true, auth: true },
    name: "RomaneioIndex",
    title: "Romaneios",
    component: () => import(`@/views/romaneio/RomaneioIndex.vue`)
  },
  {
    path: "/romaneios/:id",
    meta: { breadcrumb: true, auth: true },
    name: "Romaneio",
    title: "Romaneio",
    component: () => import(`@/views/romaneio/Romaneio.vue`)
  },
  {
    path: "/industrias",
    meta: { breadcrumb: true, auth: true },
    name: "IndustryIndex",
    title: "Industrias",
    component: () => import(`@/views/industry/IndustryIndex.vue`)
  },
  {
    path: "/industrias/novo",
    meta: { breadcrumb: true, auth: true },
    name: "IndustryNew",
    title: "Cadastrar industria",
    component: () => import(`@/views/industry/IndustryAdd.vue`)
  },
  {
    path: "/industrias/:id",
    meta: { breadcrumb: true, auth: true },
    name: "IndustryEdit",
    title: "Editar industria",
    component: () => import(`@/views/industry/IndustryAdd.vue`)
  },

  //propriedades
  {
    path: "/propriedades",
    meta: { breadcrumb: true, auth: true },
    name: "PropertyIndex",
    title: "Propriedades",
    component: () => import(`@/views/property/PropertyIndex.vue`)
  },
  {
    path: "/propriedades/novo",
    meta: { breadcrumb: true, auth: true },
    name: "PropertyAdd",
    title: "Cadastrar propriedade",
    component: () => import(`@/views/property/Property.vue`)
  },
  {
    path: "/propriedades/:id",
    meta: { breadcrumb: true, auth: true },
    name: "Property",
    title: "Editar Propriedade",
    component: () => import(`@/views/property/Property.vue`)
  },
  {
    path: "/produtores",
    meta: { breadcrumb: true, auth: true },
    name: "ExplorerIndex",
    title: "Exploradores",
    component: () => import(`@/views/property/ExplorerIndex.vue`)
  },

  /** AUXILIARES */

  //breed
  {
    path: "/auxiliares/racas",
    meta: { breadcrumb: true, auth: true },
    name: "AuxBreed",
    title: "Raças",
    component: () => import(`@/views/aux/breed/BreedIndex.vue`)
  },
  {
    path: "/auxiliares/racas/novo",
    meta: { breadcrumb: true, auth: true },
    name: "AuxBreedNew",
    title: "Adicionar raça",
    component: () => import(`@/views/aux/breed/BreedAdd.vue`)
  },
  {
    path: "/auxiliares/racas/:id",
    meta: { breadcrumb: true, auth: true },
    name: "AuxBreedEdit",
    title: "Editar raça",
    component: () => import(`@/views/aux/breed/BreedAdd.vue`)
  },

  //finish
  {
    path: "/auxiliares/acabementos",
    meta: { breadcrumb: true, auth: true },
    name: "AuxFinish",
    title: "Acabamentos",
    component: () => import(`@/views/aux/finish/FinishIndex.vue`)
  },
  {
    path: "/auxiliares/acabementos/novo",
    meta: { breadcrumb: true, auth: true },
    name: "AuxFinishNew",
    title: "Adicionar acabamento",
    component: () => import(`@/views/aux/finish/FinishAdd.vue`)
  },
  {
    path: "/auxiliares/acabementos/:id",
    meta: { breadcrumb: true, auth: true },
    name: "AuxFinishEdit",
    title: "Editar acabamento",
    component: () => import(`@/views/aux/finish/FinishAdd.vue`)
  },

  //cases
  {
    path: "/auxiliares/cases",
    meta: { breadcrumb: true, auth: true },
    name: "AuxCase",
    title: "Motivos",
    component: () => import(`@/views/aux/case/CaseIndex.vue`)
  },
  {
    path: "/auxiliares/cases/novo",
    meta: { breadcrumb: true, auth: true },
    name: "AuxCaseNew",
    title: "Adicionar motivo",
    component: () => import(`@/views/aux/case/CaseAdd.vue`)
  },
  {
    path: "/auxiliares/cases/:id",
    meta: { breadcrumb: true, auth: true },
    name: "AuxCaseEdit",
    title: "Editar motivo",
    component: () => import(`@/views/aux/case/CaseAdd.vue`)
  },

  //category
  {
    path: "/auxiliares/categorias",
    meta: { breadcrumb: true, auth: true },
    name: "AuxCategory",
    title: "Categorias",
    component: () => import(`@/views/aux/category/CategoryIndex.vue`)
  },
  {
    path: "/auxiliares/categorias/novo",
    meta: { breadcrumb: true, auth: true },
    name: "AuxCategoryNew",
    title: "Adicionar categoria",
    component: () => import(`@/views/aux/category/CategoryAdd.vue`)
  },
  {
    path: "/auxiliares/categorias/:id",
    meta: { breadcrumb: true, auth: true },
    name: "AuxCategoryEdit",
    title: "Editar categoria",
    component: () => import(`@/views/aux/category/CategoryAdd.vue`)
  },

  //conformation
  {
    path: "/auxiliares/conformacao",
    meta: { breadcrumb: true, auth: true },
    name: "AuxConformation",
    title: "Tipos de conformação",
    component: () => import(`@/views/aux/conformation/ConformationIndex.vue`)
  },
  {
    path: "/auxiliares/conformacao/novo",
    meta: { breadcrumb: true, auth: true },
    name: "AuxConformationNew",
    title: "Adicionar tipo de conformação",
    component: () => import(`@/views/aux/conformation/ConformationAdd.vue`)
  },
  {
    path: "/auxiliares/conformacao/:id",
    meta: { breadcrumb: true, auth: true },
    name: "AuxConformationEdit",
    title: "Editar tipo de conformação",
    component: () => import(`@/views/aux/conformation/ConformationAdd.vue`)
  },

  //destiny
  {
    path: "/auxiliares/destinos",
    meta: { breadcrumb: true, auth: true },
    name: "AuxDestiny",
    title: "Destinos",
    component: () => import(`@/views/aux/destiny/DestinyIndex.vue`)
  },
  {
    path: "/auxiliares/destinos/novo",
    meta: { breadcrumb: true, auth: true },
    name: "AuxDestinyNew",
    title: "Adicionar destino",
    component: () => import(`@/views/aux/destiny/DestinyAdd.vue`)
  },
  {
    path: "/auxiliares/destinos/:id",
    meta: { breadcrumb: true, auth: true },
    name: "AuxDestinyEdit",
    title: "Editar destino",
    component: () => import(`@/views/aux/destiny/DestinyAdd.vue`)
  },

  //install target
  {
    path: "/auxiliares/locais-instalacao",
    meta: { breadcrumb: true, auth: true },
    name: "AuxInstallTarget",
    title: "Locais de instalação",
    component: () => import(`@/views/aux/installtarget/InstallTargetIndex.vue`)
  },
  {
    path: "/auxiliares/locais-instalacao/novo",
    meta: { breadcrumb: true, auth: true },
    name: "AuxInstallTargetNew",
    title: "Adicionar local de instalação",
    component: () => import(`@/views/aux/installtarget/InstallTargetAdd.vue`)
  },
  {
    path: "/auxiliares/locais-instalacao/:id",
    meta: { breadcrumb: true, auth: true },
    name: "AuxInstallTargetEdit",
    title: "Editar local de instalação",
    component: () => import(`@/views/aux/installtarget/InstallTargetAdd.vue`)
  },

  //market
  {
    path: "/auxiliares/mercados",
    meta: { breadcrumb: true, auth: true },
    name: "AuxMarket",
    title: "Mercados",
    component: () => import(`@/views/aux/market/MarketIndex.vue`)
  },
  {
    path: "/auxiliares/mercados/novo",
    meta: { breadcrumb: true, auth: true },
    name: "AuxMarketNew",
    title: "Adicionar mercado",
    component: () => import(`@/views/aux/market/MarketAdd.vue`)
  },
  {
    path: "/auxiliares/mercados/:id",
    meta: { breadcrumb: true, auth: true },
    name: "AuxMarketEdit",
    title: "Editar mercado",
    component: () => import(`@/views/aux/market/MarketAdd.vue`)
  },

  //maturity
  {
    path: "/auxiliares/maturidades",
    meta: { breadcrumb: true, auth: true },
    name: "AuxMaturity",
    title: "Maturidades",
    component: () => import(`@/views/aux/maturity/MaturityIndex.vue`)
  },
  {
    path: "/auxiliares/maturidades/novo",
    meta: { breadcrumb: true, auth: true },
    name: "AuxMaturityNew",
    title: "Adicionar maturidade",
    component: () => import(`@/views/aux/maturity/MaturityAdd.vue`)
  },
  {
    path: "/auxiliares/maturidades/:id",
    meta: { breadcrumb: true, auth: true },
    name: "AuxMaturityEdit",
    title: "Editar maturidade",
    component: () => import(`@/views/aux/maturity/MaturityAdd.vue`)
  },

  //type negotiations
  {
    path: "/auxiliares/tipos-negociacao",
    meta: { breadcrumb: true, auth: true },
    name: "AuxTypeNegotiation",
    title: "Tipos de negociação",
    component: () =>
      import(`@/views/aux/typenegotiation/TypeNegotiationIndex.vue`)
  },
  {
    path: "/auxiliares/tipos-negociacao/novo",
    meta: { breadcrumb: true, auth: true },
    name: "AuxTypeNegotiationNew",
    title: "Adicionar tipo de negociação",
    component: () =>
      import(`@/views/aux/typenegotiation/TypeNegotiationAdd.vue`)
  },
  {
    path: "/auxiliares/tipos-negociacao/:id",
    meta: { breadcrumb: true, auth: true },
    name: "AuxTypeNegotiationEdit",
    title: "Editar tipo de negociação",
    component: () =>
      import(`@/views/aux/typenegotiation/TypeNegotiationAdd.vue`)
  },

  //type productions
  {
    path: "/auxiliares/tipos-producao",
    meta: { breadcrumb: true, auth: true },
    name: "AuxTypeProduction",
    title: "Tipos de produção",
    component: () =>
      import(`@/views/aux/typeproduction/TypeProductionIndex.vue`)
  },
  {
    path: "/auxiliares/tipos-producao/novo",
    meta: { breadcrumb: true, auth: true },
    name: "AuxTypeProductionNew",
    title: "Adicionar tipo de produção",
    component: () => import(`@/views/aux/typeproduction/TypeProductionAdd.vue`)
  },
  {
    path: "/auxiliares/tipos-producao/:id",
    meta: { breadcrumb: true, auth: true },
    name: "AuxTypeProductionEdit",
    title: "Editar tipo de produção",
    component: () => import(`@/views/aux/typeproduction/TypeProductionAdd.vue`)
  },

  //user
  {
    path: "/usuarios",
    meta: { breadcrumb: true, auth: true },
    name: "UserIndex",
    title: "Usuários",
    component: () => import(`@/views/users/UserIndex.vue`)
  },
  {
    path: "/usuarios/:id",
    meta: { breadcrumb: true, auth: true },
    name: "User",
    title: "Usuário",
    component: () => import(`@/views/users/User.vue`)
  },

  {
    path: "/usuarios-temporarios",
    meta: { breadcrumb: true, auth: true },
    name: "TempUsers",
    title: "Usuários Temporários",
    component: () => import(`@/views/tempUsers/index.vue`)
  },

  // Reports
  {
    path: "/reports/abate-ao-vivo",
    meta: { breadcrumb: true, auth: true },
    name: "ReportOnlineSlaughter",
    title: "Relatório Abate ao Vivo",
    component: () => import(`@/views/reports/OnlineSlaughterReport.vue`)
  },

  // Apis
  {
    path: "/apis/documentations/users",
    meta: { breadcrumb: true, auth: true },
    name: "Documentations",
    title: "Documentações",
    component: () => import(`@/views/apis/documentations/Users.vue`)
  }
];
